export default __webpack_public_path__ + "static/media/cpfleets.e00352ba.png";